/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SmsMessage = {
    properties: {
        message: {
    type: 'string',
    isRequired: true,
},
        direction: {
    type: 'Enum',
    isRequired: true,
},
        from: {
    type: 'string',
    isRequired: true,
},
        to: {
    type: 'array',
    contains: {
    type: 'string',
},
    isRequired: true,
},
        dateSent: {
    type: 'string',
    isRequired: true,
},
        status: {
    type: 'Enum',
    isRequired: true,
},
        uri: {
    type: 'string',
    isRequired: true,
},
        media: {
    type: 'dictionary',
    contains: {
    type: 'string',
},
    isNullable: true,
},
    },
};